import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react';

import { Breadcrumb } from '@app/components/home/Breadcrumb';
import { useHeadMeta } from '@app/hooks/useHeadMeta';
import { cn } from '@app/libs/utils';
import { infoService } from '@app/services/info.service';
import { withLayout } from '@components/withLayout';

export const getServerSideProps: GetServerSideProps = async ctx => {
  const { data, success, message, error } = await infoService
    .setServerContext(ctx.req, ctx.res)
    .setCookies(ctx.req.headers.cookie || '')
    .get('term');
  return {
    props: {
      data: data || null,
      success,
      message,
      error: error ?? null,
    },
  };
};

const TermPage: React.FC = (props: any) => {
  const { data } = props;
  const { setTitle, setDescription, setKeywords } = useHeadMeta();

  useEffect(() => {
    setTitle('Điều khoản và điều kiện sử dụng');
    setDescription('Điều khoản và điều kiện sử dụng');
    setKeywords('Điều khoản và điều kiện sử dụng');
  }, [setTitle, setDescription, setKeywords]);

  return (
    <>
      <div className="bg-gray-200/80 -mb-15">
        <Breadcrumb
          items={[{ label: 'Điều khoản và điều kiện sử dụng', href: '/term' }]}
          className={cn('w-auto 2xl:w-[90rem] p-5 sm:px-6 text-gray-900 text-sm flex mx-auto')}
        />
      </div>
      <section className="w-full">
        <div className="2xl:w-[90rem] w-full mx-auto px-5 py-10">
          <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: data }} />
        </div>
      </section>
    </>
  );
};

export default withLayout(TermPage);
